import React from "react";
import CustomInput from "../CustomInput/CustomInput";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { useIntl } from "react-intl";
import { addUserFormFieldNames } from "../../validationSchema/addUserManagementSchema";

export default function GlobalIdFieldComponent({
  values,
  touched,
  errors,
  handleChange,
  onBlur,
}) {
  const intl = useIntl();
  return (
    <CustomInput
      size={"small"}
      required
      label={getLocalizedMessage(intl, "addUser.addGlobalID")}
      placeholder={getLocalizedMessage(
        intl,
        "addUser.addUserGlobalId.placeholder"
      )}
      name={addUserFormFieldNames.GLOBAL_ID}
      value={values[addUserFormFieldNames.GLOBAL_ID]}
      onChange={handleChange}
      error={
        touched[addUserFormFieldNames.GLOBAL_ID] &&
        errors[addUserFormFieldNames.GLOBAL_ID]
      }
      onBlur={onBlur}
    />
  );
}
